import axios from 'axios'
import {ElMessage} from "element-plus";
import {ElLoading} from "element-plus";
import commons from "@/assets/utils/commons";
import router from "@/router/index";
import { useRouter,useRoute } from 'vue-router'


let loginMess = commons.readLocalStorage('loginMess') || {} as any;
let loading = "" as any;


const  ajax = axios.create({
    // baseURL: '/api',   //所有的请求地址前缀部分
    timeout: 60000,    //请求超时时间毫秒
    withCredentials: true ,  //异步请求携带cookie
    method: 'post',
    headers: {
        'Content-type': 'application/json',
    }
});
axios.defaults.withCredentials = true;
//添加请求拦截器
ajax.interceptors.request.use(
    (beforeFunc:any) => {

        if(!(beforeFunc.data && beforeFunc.data.noload)) {
            loading = ElLoading.service({
                text: '加载中...',
                background: 'rgba(0, 0, 0, 0.7)',
            });
        }


        loginMess = commons.readLocalStorage('loginMess') || {} as any;

        if(loginMess && loginMess.token  && (!beforeFunc.data || !beforeFunc.data.nocheck) ) {
            if(!(beforeFunc.data && beforeFunc.data.nocheck))  beforeFunc.headers['X-Stone-H5-Token'] = loginMess.token ;
        }

            // beforeFunc.data = qs.stringify(beforeFunc.data)
            //发送请求之前做些什么
      return beforeFunc
  },
   error => {
      //对请求错误做些什么
      return Promise.reject(error)
  }
);


//添加相应拦截器
ajax.interceptors.response.use(
    response => {
        const data :any  = response.data;
        loading && loading.close();
        if(data.status === 501 || data.status === 507) {
            commons.clearLocalStorage();
            router.push(`/login`);
            ElMessage.error(data.message || '请重新登录');
            return;
        }
        return data;
    },
    error => {
        return Promise.reject(error)
    }
);

export default ajax

